import { useEffect, useRef, useState } from "react";
import React from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import BottomNavigationBar from "../BottomNavigation";
import "../GridFilter.css";
import "datatables.net";
import moment from "moment";
import dayjs from "dayjs";
import FilterListIcon from "@mui/icons-material/FilterList";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TablePagination } from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  setTransportList,
  setTravelType,
  setSectors,
  setActualTransportData,
} from "../../Store/Slices/countrySlice";

import $ from "jquery";
import "datatables.net";
import "datatables.net-fixedheader";
import { SendPostRequest } from "../ApiRequest";
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BounceLoader } from "react-spinners";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";

import {
  setCountry,
  setCountryList,
  setAgent,
  setCity,
  setHotel,
  setArrivalDate_From,
  setArrivalDate_to,
  setCheckinDate,
  setCheckoutDate,
  setCompleted,
  setLength,
  clearFilter,
  setModalParams,
} from "../../Store/Slices/countrySlice";
import { DatePicker, Space } from "antd";
import { makePostRequest } from "../../API";
import { getCurrentYearDatesISO } from "../../Helper/Helper";
import AllowTransportReturnModal from "../reuseableComponents/AllowTransportReturnModal";
import AllowHotalModal from "../reuseableComponents/Modals/AllowHotalModal";
const { RangePicker } = DatePicker;

function ActualMakkahTptGrid() {
  const [loading, setLoading] = useState(false);
  const dateFormat = "YYYY-MM-DD";
  const storeState = useSelector((state) => state);
  const modalMapping = storeState.Country.modalMapping;

  const dispatch = useDispatch();

  const state_endpoints_mapping = {
    agent_country: {
      endpoint: "api/agent",
      field: "country_code",
      dispatchFunction: setAgent,
      dependent: "agents",
    },
    country: {
      endpoint: "api/world/cities",
      field: "country_id",
      dispatchFunction: setCity,
      dependent: "city",
    },
    city: {
      endpoint: "api/hotel",
      field: "city_id",
      dispatchFunction: setHotel,
      dependent: "hotel",
    },
    voucherId: null,
    agent: null,
    hotel: null,
    arrivalDate: null,
    returnDate: null,
    checkIn: null,
    checkOut: null,
    completed: null,
  };

  const { firstDate, lastDate } = getCurrentYearDatesISO();

  const [state, setState] = useState({
    length: 100,
    start: 0,
    draw: 1,
    voucher_id: "",
    agent_country: "",
    country: "",
    agents: "",
    city: 258342,
    transport: "",
    travel_type: "",
    Sector: "",
    arrival_date_from: firstDate,
    arrival_date_to: lastDate,
    return_date_from: firstDate,
    return_date_to: lastDate,
    travel_date_from: firstDate,
    travel_date_to: lastDate,
    completed: "no",
  });

  const loadData = async (state_id, value) => {
    if (state_endpoints_mapping[state_id] == null) return;

    setLoading(true);

    const response = await SendPostRequest(
      state_endpoints_mapping[state_id].endpoint,
      { [state_endpoints_mapping[state_id].field]: value }
    );

    if (response.status == "success") {
      dispatch(
        state_endpoints_mapping[state_id].dispatchFunction(response.data)
      );
      // setState({
      //   ...state,
      //   [state_endpoints_mapping[state_id].dependent]: response.data,
      // });
    }

    setLoading(false);
  };

  const handleChange = async (e) => {
    e.preventDefault();
    const { id, value } = e.target;

    if (id === "country") {
      setState((prev) => ({
        ...prev,
        [id]: value,
        city: "", // reset selected agent
      }));
    } else {
      setState((prev) => ({
        ...prev,
        [id]: value,
      }));
    }

    // setState({ ...state, [id]: value });
    await loadData(id, value);
  };

  const [isFormVisible, setFormVisible] = useState(false);

  const handleFilterClick = () => {
    setFormVisible(!isFormVisible);
  };

  const [tableData, setTableData] = useState([]);

  const [expandedRows, setExpandedRows] = useState([]);

  const toggleExpansion = (index) => {
    const newExpandedRows = [...expandedRows];
    newExpandedRows[index] = !newExpandedRows[index];
    setExpandedRows(newExpandedRows);
  };

  // date work start

  const [DateError, SetDateError] = useState({
    arivalErrorFrom: false,
    arivalError: false,
    returnFrom: false,
    returnTo: false,
    travelFrom: false,
    travelTo: false,
  });

  const handle_date_from = (e, positionFrom, ErrorPosition, StateCompare) => {
    const date_from = moment(e.$d).format(dateFormat);
    setState((prevState) => ({
      ...prevState,
      [positionFrom]: date_from,
    }));

    if (date_from && state[StateCompare] && date_from > state[StateCompare]) {
      SetDateError({
        ...DateError,
        [ErrorPosition]: true,
      });

      setState((prevState) => ({
        ...prevState,
        [positionFrom]: null,
      }));
    } else {
      SetDateError({
        ...DateError,
        [ErrorPosition]: false,
      });
    }
  };

  const handle_date_to = (
    e,
    positionto,
    DateErrorTo,
    DateErrorFrom,
    StateCompare
  ) => {
    const date_to = moment(e.$d).format(dateFormat);

    if (!state[StateCompare] || (date_to && date_to >= state[StateCompare])) {
      setState({
        ...state,
        [positionto]: date_to,
      });

      SetDateError({
        ...DateError,
        [DateErrorTo]: false,
        [DateErrorFrom]: false,
      });
    } else {
      setState({
        ...state,
        [positionto]: null,
      });

      SetDateError({
        ...DateError,
        [DateErrorTo]: true,
      });
    }
  };

  // adding a  background white when we scroll down
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // new pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0); // new state
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setExpandedRows([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // reset to first page
  };

  const [activeFilters, setActiveFilters] = useState(null);

  const fetchData = async (filters = null) => {
    const endpoint = "api/umrah/actual-transport-activity";

    const params = filters
      ? { ...filters, length: rowsPerPage, start: page * rowsPerPage, draw: 1 }
      : {
          length: rowsPerPage,
          start: page * rowsPerPage,
          draw: 1,
          // check_in_date_from: "2024-07-01",
          // check_in_date_to: "2025-08-31",
          city: 258342,
        };

    try {
      setLoading(true);
      const response = await SendPostRequest(endpoint, params);
      setLoading(false);

      if (response?.data?.data) {
        setTableData(response.data.data);
        setTotalRecords(response.data.recordsTotal || response.data.total || 0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(activeFilters);
  }, [page, rowsPerPage]);

  // bring it on single pages

  const [apiCountry, setApiCountry] = useState([]);
  const [apiagent, setApiagent] = useState([]);

  // multi set later using an object

  const [list, setList] = useState({
    transport: [],
    travalType: [],
    sectors: [],
  });

  // change later
  useEffect(() => {
    const fetchData = async () => {
      try {
        const countries = await makePostRequest("api/world/countries");

        if (!countries) return;
        const contryList = countries.data.map((country) => {
          return [country.ISO2, country.Name];
        });
        dispatch(setCountryList(contryList));

        const transport = await makePostRequest("api/transport");
        const transportList = transport.data.map((transport) => {
          return [transport.Name, transport.UID];
        });

        setList((prev) => ({
          ...prev,
          transport: transportList,
        }));

        dispatch(setTransportList(transportList));

        const travelType = await makePostRequest("api/travel");
        dispatch(setTravelType(Object.entries(travelType.data)));

        const sectors = await makePostRequest("api/transport/sector");
        const sectorsList = sectors.data.map((sector) => {
          return [sector.Name, sector.UID];
        });
        dispatch(setSectors(sectorsList));
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  // country
  useEffect(() => {
    const fetchdata = async () => {
      try {
        const countries = await makePostRequest("/api/world/countries");

        const contryList = countries.data.map((country) => {
          return [country.ISO2, country.Name];
        });

        setApiCountry(contryList);
      } catch (error) {
        console.log(error?.message);
      }
    };
    fetchdata();
  }, []);

  const handleCountryChange = async (selectedCountry) => {
    // Reset agent list when no country is selected

    setState((prev) => ({
      ...prev,
      agent_country: selectedCountry,
      agents: "", // reset selected agent
    }));

    if (!selectedCountry) {
      setApiagent([]);
      return;
    }

    try {
      setState((prevState) => ({
        ...prevState,
        agent_country: selectedCountry,
      }));

      const response = await makePostRequest("/api/agent", {
        country_code: selectedCountry,
      });

      setApiagent(response?.data ?? []);
    } catch (error) {
      console.error("Error fetching agent data:", error.message);
      setApiagent([]);
    }
  };

  // for steting modals---------------------------
  const [selectedActions, setSelectedActions] = useState({});
  const [open, setOpen] = React.useState(false);
  const [openReturnVoucher, setOpenReturnVoucher] = useState(false);
  const [sendDataToModal, setSendDataToModal] = useState(null);

  const handleNavigate = (e, index) => {
    const selectedValue = e.target.value;




    setSelectedActions((prev) => ({
      ...prev,
      [index]: selectedValue,
    }));
const [voucherId, key, record_id, param, refrance_type] =   selectedValue.split(",").map(v => v === "" ? null : v);


 
 let parsedData = {
    voucher_id: Number(voucherId),
    key: key,
    record_id: Number(record_id),
    actual_param:param,
    reference_type:refrance_type,
  };

    setSendDataToModal(parsedData);

    if (parsedData?.key === "transport") {
      setOpenReturnVoucher(true);
    } else {
      setOpen(true);
    }
  };

  useEffect(()=>{
     window.scrollTo({ top: 0, behavior: "smooth" });
},[open])
  // consoles

  // console.log("this is dashboard data that we get",dashboardData)

  // console.log("storeState.Country.agents",storeState.Country.agents)

  // console.log("apiagent",apiagent)
  // console.log("apiCountry",apiCountry)
  // console.log("this is state",state)
  // console.log("sendDataToModal",sendDataToModal)
  // console.log("list", list);
  const hasNoDateErrors = Object.values(DateError).every(v => v === false);

  // console.log("DateError.travelTo",DateError.travelTo)

  return (
    <div>
      <MDBContainer breakpoint=" ">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div className="row mb-5 ">
            <div
              className={`mb-3 grid-filter-inputs flex-display-container align-items-center  sticky-top rounded  p-4 ${
                isScrolled ? "bg-white" : ""
              } `}
            >
              <h1 className="main-hading main-heading-reset">
                Actual Makkah Tpt
              </h1>
              <button onClick={handleFilterClick} className="filter-button">
                Filters {<FilterListIcon />}
              </button>
            </div>
            <div className="row">
              <hr />
            </div>
            {isFormVisible && (
              <div className="row">
                <div className="col-md-12 mx-auto">
                  <div className="row">
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="voucher_id" className="lableSize">
                          Voucher ID
                        </label>
                        <input
                          type="text"
                          className="form-control inputSize"
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          onChange={handleChange}
                          id="voucher_id"
                          name="VoucherId"
                          placeholder="Voucher ID"
                          value={state.voucher_id}
                        />
                      </div>
                    </div>
                    {/* this is agent counrty  */}

                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="agent_country" className="lableSize">
                          Agent Country{" "}
                        </label>

                        <select
                          className="form-control inputSize"
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          id="agent_country"
                          name="AgentCountry"
                          onChange={(e) => handleCountryChange(e.target.value)}
                          value={state.agent_country}
                        >
                          <option value="">Please Select</option>
                          {apiCountry?.map((country) => {
                            return (
                              <option key={country[0]} value={country[0]}>
                                {country[1]}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>

                    {/* this is agent  */}

                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="agents" className="lableSize">
                          Agents
                        </label>

                        <select
                          className="form-control inputSize"
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          id="agents"
                          value={state.agents || ""} // ✅ use state, not apiagent array
                          onChange={handleChange}
                        >
                          <option value="">Select Agent</option>
                          {state.agent_country === "" ? (
                            <option value="">Select Agent Country first</option>
                          ) : apiagent.length === 0 ? (
                            <option value="">No agent available</option>
                          ) : (
                            apiagent.map((ag) => (
                              <option key={ag.UID} value={ag.UID}>
                                {ag.FullName}
                              </option>
                            ))
                          )}
                        </select>
                      </div>
                    </div>
                    {/* country */}
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="country" className="lableSize">
                          Country{" "}
                        </label>

                        <select
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          className="form-control inputSize"
                          id="country"
                          name="Country"
                          onChange={handleChange}
                          value={state.country}
                        >
                          <option value="">Please Select</option>
                          {apiCountry?.map((country) => (
                            <option key={country[0]} value={country[0]}>
                              {country[1]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {/* city */}
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="city" className="lableSize">
                          City
                        </label>

                        <select
                          className="form-control inputSize"
                          id="city"
                          name="City"
                          onChange={handleChange}
                          value={state.city}
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.city.map((city) => (
                            <option key={city.UID} value={city.UID}>
                              {city.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {/* transport  */}
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="transport" className="lableSize">
                          Transport
                        </label>

                        <select
                          className="form-control inputSize"
                          id="transport"
                          name="Transport"
                          onChange={handleChange}
                          value={state.transport}
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                        >
                          <option value="">Please Select</option>
                          {list.transport.map((trans) => (
                            <option key={trans[1]} value={trans[1]}>
                              {trans[0]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* traval Type  */}

                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="travel_type" className="lableSize">
                          Travel Type
                        </label>

                        <select
                          className="form-control inputSize"
                          id="travel_type"
                          name="travel_type"
                          value={state.travel_type}
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          onChange={handleChange}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.travelType.map((trans) => (
                            <option key={trans[0]} value={trans[0]}>
                              {trans[1]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="Sector" className="lableSize">
                          Sector
                        </label>

                        <select
                          className="form-control inputSize"
                          id="Sector"
                          name="Sector"
                          value={state.Sector}
                          onChange={handleChange}
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.sectors.map((sector) => {
                            return (
                              <option key={sector[1]} value={sector[1]}>
                                {sector[0]}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    {/* ARIVAL-------------------------------------------------------------- */}

                    <label
                      for="arrival_date"
                      className="fs-1 text-center mt-3 "
                    >
                      Arrival Date
                    </label>

                    <div className="col-md-2 mb-1">
                      <div className="form-group">
                        <label for="arrival_date" className="fs-2">
                          {" "}
                          From
                        </label>

                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                             "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                          }}
                        >
                          <MobileDatePicker
                            value={dayjs(state.arrival_date_from, dateFormat)}
                            onChange={(e) =>
                              handle_date_from(
                                e,
                                "arrival_date_from",
                                "arivalErrorFrom",
                                "arrival_date_to"
                              )
                            }
                            className=""
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: "none",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                               "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                            }}
                          />
                        </DemoContainer>

                        {DateError.arivalErrorFrom ||
                        (DateError.arivalErrorFrom &&
                          state.arrival_date_from == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT ARIVAL FROM DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        <label for="arrival_date" className="fs-2 mt-3">
                          {" "}
                          To
                        </label>
                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                             "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                          }}
                          autoFocus={false}
                        >
                          <MobileDatePicker
                            value={dayjs(state.arrival_date_to, dateFormat)}
                            className=" "
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border:  "none",
                                outline: DateError.arivalError ? "none" : "",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                               "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                            }}
                            onChange={(e) =>
                              handle_date_to(
                                e,
                                "arrival_date_to",
                                "arivalError",
                                "arivalErrorFrom",
                                "arrival_date_from"
                              )
                            }
                            autoFocus={false}
                          />
                        </DemoContainer>

                        {DateError.arivalError ||
                        (DateError.arivalError &&
                          state.arrival_date_to == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT ARIVAL TO DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    {/* end Arival  */}
                    {/* RETURN-------------------------------------------------------------- */}
                    <label
                      for="arrival_date"
                      className="fs-1 text-center mt-3 "
                    >
                      {" "}
                      Return Date{" "}
                    </label>
                    <div className="col-md-2 mb-1">
                      <div className="form-group">
                        <label for="arrival_date" className="fs-2">
                          {" "}
                          From
                        </label>

                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                             "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                          }}
                        >
                          <MobileDatePicker
                            value={dayjs(state.return_date_from, dateFormat)}
                            onChange={(e) =>
                              handle_date_from(
                                e,
                                "return_date_from",
                                "returnFrom",
                                "return_date_to"
                              )
                            }
                            className=""
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: "none",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                               "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                            }}
                          />
                        </DemoContainer>

                        {DateError.returnFrom ||
                        (DateError.returnFrom &&
                          state.return_date_from == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT RETURN FROM DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        <label for="arrival_date" className="fs-2 mt-3">
                          {" "}
                          To
                        </label>
                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                             "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                          }}
                          autoFocus={false}
                        >
                          <MobileDatePicker
                            value={dayjs(state.return_date_to, dateFormat)}
                            className=" "
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: "none",
                                outline: DateError.returnTo ? "none" : "",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                               "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                            }}
                            onChange={(e) =>
                              handle_date_to(
                                e,
                                "return_date_to",
                                "returnTo",
                                "returnFrom",
                                "return_date_from"
                              )
                            }
                            autoFocus={false}
                            // Add custom class here
                          />
                        </DemoContainer>

                        {DateError.returnTo ||
                        (DateError.returnTo && state.return_date_to == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT RETURN TO DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    {/* TRAVEL DATE-------------------------------------------------------------- */}

                    <label
                      for="
                        travel_date"
                      className="fs-1 text-center mt-3 "
                    >
                      {" "}
                      Travel Date{" "}
                    </label>
                    <div className="col-md-2 mb-1">
                      <div className="form-group">
                        <label for="travel_date_from" className="fs-2">
                          {" "}
                          From
                        </label>

                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                             "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                          }}
                        >
                          <MobileDatePicker
                            onChange={(e) =>
                              handle_date_from(
                                e,
                                "travel_date_from",
                                "travelFrom",
                                "travel_date_to"
                              )
                            }
                            value={dayjs(state.travel_date_from, dateFormat)}
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border:  "none",
                                outline: DateError.travelFrom ? "none" : "",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                               "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                            }}
                          />
                        </DemoContainer>

                        {DateError.travelFrom ||
                        (DateError.travelFrom &&
                          state.travel_date_from == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT RETURN FROM DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        <label for="arrival_date" className="fs-2 mt-3">
                          {" "}
                          To
                        </label>

                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "transparent", // Prevents border from appearing
                              },
                            },
                             "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                          }}
                          autoFocus={false}
                        >
                          <MobileDatePicker
                            value={dayjs(state.travel_date_to, dateFormat)}
                            className=" "
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor:  "transparent",
                                },
                                "&:hover fieldset": {
                                  borderColor: "gray",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor:  "#1976d2",
                                },
                              },
                               "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                            }}
                            onChange={(e) =>
                              handle_date_to(
                                e,
                                "travel_date_to",
                                "travelTo",
                                "travelFrom",
                                "travel_date_from"
                              )
                            }
                            autoFocus={false}
                          />
                        </DemoContainer>

                        {DateError.travelTo ||
                        (DateError.travelTo && state.travel_date_to == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT RETURN TO DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    {/* date section end ---------------------------------------------------------------------------------------- */}
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="completed" className="lableSize">
                          Completed
                        </label>
                        <select
                          className="form-control inputSize"
                          id="completed"
                          name="completed"
                          value={state.completed}
                          onChange={handleChange}
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                        >
                          <option value="">Please Select</option>
                          <option value="yes">Yes</option>
                          <option value="no" selected="">
                            No
                          </option>
                        </select>
                      </div>
                    </div>
                    <div
                      className="col-md-12"
                      id="AllowTransportActiviitesAjaxResult"
                    ></div>
                    <div className="col-md-12" id="FilterButtons">
                      <div className="form-group htjfdgr">
                        <button
                          style={{ marginRight: "12px", padding: "8px 25px" }}
                          onClick={() => {
                            setActiveFilters(state);
                            setPage(0);
                            fetchData(state);
                          }}
                            disabled={!hasNoDateErrors} 
                          id="btnsearch"
                          type="button"
                          className="btn btn-success fs-1"
                        >
                          Search
                        </button>
                  




    <button
                            onClick={() =>{
   SetDateError({    

     arivalErrorFrom: false,
    arivalError: false,
    returnFrom: false,
    returnTo: false,
    travelFrom: false,
    travelTo: false,
  
  
  })
                            

setActiveFilters(null);
setPage(0);
 setState({
                              length: 100,
                              start: 0,
                              draw: 1,
                              voucher_id: "",
                              agent_country: "",
                              country: "",
                              agents: "",
                               city: 258342,
                              transport: "",
                              travel_type: "",
                              Sector: "",
                              arrival_date_from: null,
                              arrival_date_to: null,
                              return_date_from: null,
                              return_date_to: null,
                              travel_date_from: null,
                              travel_date_to: null,
                              completed: "no",
                            })
                            fetchData()
                          }



                          }
             
                          id="btnreset"
                          type="button"
                          className="btn btn-danger  fs-1"
                          style={{ padding: "8px 25px" }}
                        >
                          Clear Filter
                        </button>




                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div style={{ marginBottom: "20px" }}>
           
  <Paper sx={{ padding: "0px 20px" }}>
                <Table
                  id="example"
                  className="table table-striped dt-responsive nowrap table-display w-100"
                >
                  {/* Table Head */}
                  <TableHead>
                    <TableRow>
                      <TableCell component="th" sx={{ fontWeight: "bold" }}>
                        Voucher
                      </TableCell>
                      <TableCell component="th" sx={{ fontWeight: "bold" }}>
                        Travel Date
                      </TableCell>
                      <TableCell component="th" sx={{ fontWeight: "bold" }}>
                        No of seats
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {/* Table Body */}
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell
                          colSpan={3}
                          align="center"
                          style={{ height: "35vh" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                            }}
                          >
                            <BounceLoader className="BouncingLoader" />
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : totalRecords === 0 ? (
                      <TableRow>
                        <TableCell
                          colSpan={3}
                          align="center"
                          style={{ height: "25vh" }}
                        >
                          <h3 className="pt-5">No data found</h3>
                        </TableCell>
                      </TableRow>
                    ) : (
                      tableData?.map((item, index) => (
                        <React.Fragment key={index}>
                          <TableRow>
                            <TableCell
                              component="td"
                              sx={{ cursor: "pointer" }}
                              onClick={() => toggleExpansion(index)}
                            >
                              {item.voucher_id || "--"}
                            </TableCell>
                            <TableCell component="td">
                              {item.travel_date}
                            </TableCell>
                            <TableCell component="td">
                              {item.no_of_seats || "--"}
                            </TableCell>
                          </TableRow>

                          {/* Expanded Row */}
                          {expandedRows[index] && (
                            <TableRow>
                              <TableCell component="td" colSpan={3}>
                                <div className="row">
                                  {/* Display standard fields */}
                                  {[
                               




                                    // {
                                    //   label: "No Of Seats",
                                    //   value: item.no_of_seats || "--",
                                    //   colClass: "col-6",
                                    // },
                                    {
                                      label: "Vehicle No",
                                      value: item.vehicle_no || "--",
                                      colClass: "col-6",
                                    },
                                    {
                                      label: "Vehicle Company",
                                      value: item.vehicle_company || "--",
                                      colClass: "col-6",
                                    },
                                    {
                                      label: "Transport Type",
                                      value: item.transport_type_name || "--",
                                      colClass: "col-12",
                                    },
                                 
                                  


                                    
                                  ].map((field, idx) => (
                                    <div
                                      key={idx}
                                      className={`${field.colClass} d-flex flex-column mb-3`}
                                    >
                                      <b>{field.label}:</b> {field.value}
                                    </div>
                                  ))}

                                

                                  {Array.isArray(item["0"]) && (
                                    <div className="col-6 d-flex flex-column mb-3">
                                      <label htmlFor={`action-select-${index}`}>
                                        <b>Action</b>
                                      </label>
                                      <select
                                        id={`action-select-${index}`}
                                        className="form-select py-3"
                                       onChange={(e) => handleNavigate(e, index)}
                                        value={selectedActions[index] || ""}
                                       
                                      >
                                        <option value="" selected disabled>
                                          -- Select an Action --
                                        </option>
                                        {item["0"].map((opt, idx) => (
                                          <option
                                            key={idx}
                                            value={opt.action.join(",")}
                                          >
                                            {opt.label}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  )}
                                </div>
                              </TableCell>
                            </TableRow>
                          )}
                        </React.Fragment>
                      ))
                    )}
                  </TableBody>

                  {/* Pagination */}
                  <TablePagination
                    rowsPerPageOptions={[10, 15, 20]}
                    component="paper"
                    count={totalRecords}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                   sx={{
                "& .MuiTablePagination-displayedRows": { margin: 0 },
                "& .MuiTablePagination-selectLabel": { margin: 0 },
                "& .MuiSelect-select": { margin: 0 },
                 "& .MuiTablePagination-actions": { marginLeft: 0 }, 
              }}

                  />
                </Table>
              </Paper>
             



  < AllowHotalModal
      
          open={open}
          setOpen={setOpen}
          sendDataToModal={sendDataToModal}   
          setSendDataToModal={setSendDataToModal}
           setSelectedActions={setSelectedActions}
           setFormVisible={setFormVisible}
        />




              <AllowTransportReturnModal
                open={openReturnVoucher}
                setOpen={setOpenReturnVoucher}
                sendDataToModal={sendDataToModal}
              />
            </div>
          </div>
        </LocalizationProvider>
      </MDBContainer>
      <div>
        <BottomNavigationBar />
      </div>
    </div>
  );
}

export default ActualMakkahTptGrid;
